import { inject, observer } from 'mobx-react'
import React, { ReactNode } from 'react'
import { AuthStore, RootStore } from 'stores'
import styled from 'styled-components'
import { theme } from '../config'

export interface IPageBodyProps {
  children?:     ReactNode,
  rootStore?:    RootStore,
  authStore?:    AuthStore,
}

const StyledPageBody = styled.div<{ sidebarWidth: string }>`
  height:         100%;
  width:          100%;
  margin-top:     calc(${theme.topbarHeight} + 2rem);
  padding-bottom: 4rem;
`

export const PageBody = inject('rootStore', 'authStore')(observer((props: IPageBodyProps): JSX.Element => {
  const { children } = props;

  return (
    <StyledPageBody sidebarWidth={theme.drawerWidth}>
      {children}
    </StyledPageBody>
  );
}));
